// 更新证件
const updateInfo = () => import(`@/views/expiredCertificationUpdateInfo/index`)
export const expiredCertificationUpdateInfo = [
  {
    path: '/expiredCertificationUpdateInfo',
    name: 'expiredCertificationUpdateInfo',
    component: updateInfo,
    meta: {
      title: '更新证件',
      navBar: false
    }
  }
]
